import { Button } from 'primereact/button';
import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { RadioButton } from "primereact/radiobutton";
import React from "react"

import { fileTypeList, UploadFileSizeLimit } from "../../entities/Constants";
import { DialogBase, Props, State } from "./DialogBase";

export class DialogForFileComponent extends DialogBase<Props,State> {
    dateTypeFieldList = [];
    constructor(props: Props) {
        super(props);

        if (!this.props.ele.FileUpload?.AllowedForUploadFileTypeList) {
            this.props.ele.FileUpload = {...this.props.ele.FileUpload ?? {}, AllowedForUploadFileTypeList: []};
        }

    }

    generateHtmlString = () => {
        let html = [];
        html.push(
            <>
                {/* @ts-ignore */}
                <Dialog header={this.props.isEng ? "Field Properties for " + this.props.ele.ENUTitle : "Field Properties for " + this.props.ele.FRATitle} footer={this.renderFooter()}
                    visible={this.props.dialogVisible} style={{ width: '50vw' }} onHide={() => this.props.callback(false)}>
                    {this.otherPreviousDateFields()}
                </Dialog>
            </>
        );
        return html;
    }

    otherPreviousDateFields = () => {
        let htmlString = [];
        if (!this.props.ele.FileUpload) {
            this.props.ele.FileUpload = {AllowedForUploadFileTypeList: [], FileSizeLimit: UploadFileSizeLimit.size, SizeUnite: UploadFileSizeLimit.unite, UploadStyle: 'default'};
            this.props.callback();
        }
        // Initialize UploadStyle to 'default' if not set
        if (!this.props.ele.FileUpload.UploadStyle) {
            this.props.ele.FileUpload.UploadStyle = 'default';
            this.props.callback();
        }
        

        htmlString.push(
            <div>
                {this.updateBindingFieldHtml()}

                {this.questionHintHtml()}

                {this.emptyErrorMessageHtml()}

                {this.errorMessageHtml()}

                {this.tooTipHtml()}

                {this.hintExpansionTitleHtml()}

                {this.calloutBoxHtml()}

                {this.scriptHtml()}

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Upload Title</div>
                    <div style={{ width: '60%' }}>
                        <InputText
                            className="ontario-input"
                            key={"upload-title-" + this.props.ele.Sequence}
                            value={
                                this.props.ele.FileUpload?.UploadField?.title?.[this.props.isEng ? 'en' : 'fr'] ??
                                (this.props.isEng ? "Choose a file" : "Choisissez un fichier")
                            }
                            onChange={(e) => {
                                const lang = this.props.isEng ? 'en' : 'fr';
                                const uploadTitle = e.target.value;
                                const currentUploadField = this.props.ele.FileUpload?.UploadField ?? {};
                                const currentTitle = currentUploadField.title ?? {};

                                const UploadField = {
                                    ...currentUploadField,
                                    title: {
                                        ...currentTitle,
                                        [lang]: uploadTitle
                                    }
                                };
                                this.props.ele.FileUpload = {...this.props.ele.FileUpload ?? {}, UploadField};
                                this.props.callback();
                            }}
                        />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Field label</div>
                    <div style={{ width: '60%' }}>
                        <InputText className="ontario-input" key={"field-label" + this.props.ele.Sequence}
                            value={this.props.ele.FileUpload?.UploadField?.label?.[this.props.isEng ? 'en' : 'fr']}
                            onChange={(e) => {
                                const lang = this.props.isEng ? 'en' : 'fr';
                                const label = e.target.value;
                                const UploadField = {...this.props.ele.FileUpload?.UploadField ?? {}, label: {[lang as ('en' | 'fr')]: label}}
                                this.props.ele.FileUpload = {...this.props.ele.FileUpload ?? {}, UploadField};
                                this.props.callback();
                            }}
                        />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Allowed file types</div>
                    <div style={{ width: '60%' }}>
                        {this.generateAllowedFileTypeHtml()}
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Validate XML files</div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Checkbox inputId={`file-upload-validate-xml-${this.props.ele.Id}`}
                            name={`validateXML-${this.props.ele.Id}`}
                            value={this.props.ele.FileUpload?.validateXML}
                            checked={this.props.ele.FileUpload?.validateXML}
                            onChange={(e)=>{
                                this.props.ele.FileUpload = {...this.props.ele.FileUpload, validateXML: e.target.checked}
                                this.props.callback();
                            }}
                        />
                        <label htmlFor={`file-upload-validate-xml-${this.props.ele.Id}`} style={{marginLeft: '8px'}}>
                            Enable XML validation (well-formed check and 20MB attachment limit)
                        </label>
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Is Bxp custom error Message</div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Checkbox inputId={`file-upload-bxpCustomerrorMessage-${this.props.ele.Id}`}  
                            name={`bxpCustomErrorMessage-${this.props.ele.Id}`}
                            value={this.props.ele.FileUpload?.isBXPCustomErrorMessage}
                            checked={this.props.ele.FileUpload?.isBXPCustomErrorMessage}
                            onChange={(e)=>{
                                this.props.ele.FileUpload = {...this.props.ele.FileUpload, isBXPCustomErrorMessage: e.target.checked}
                                this.props.callback();
                            }}
                        />
                    </div>
                </div>

                
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Allow duplicate file name</div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Checkbox inputId={`file-upload-allow-duplicate-${this.props.ele.Id}`}  
                            name={`allowDuplicate-${this.props.ele.Id}`}
                            value={this.props.ele.FileUpload?.allowDuplicateName}
                            checked={this.props.ele.FileUpload?.allowDuplicateName}
                            onChange={(e)=>{
                                this.props.ele.FileUpload = {...this.props.ele.FileUpload, allowDuplicateName: e.target.checked}
                                this.props.callback();
                            }}
                        />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Preview file</div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Checkbox inputId={`file-upload-preview-${this.props.ele.Id}`}  
                            name={`previewFile-${this.props.ele.Id}`}
                            value={this.props.ele.FileUpload?.PreviewFile}
                            checked={this.props.ele.FileUpload?.PreviewFile}
                            onChange={(e)=>{
                                this.props.ele.FileUpload = {...this.props.ele.FileUpload, PreviewFile: e.target.checked}
                                this.props.callback();
                            }}
                        />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Preview button vertical align</div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Checkbox inputId={`file-upload-preview-vertical-${this.props.ele.Id}`}  
                            name={`previewVertical-${this.props.ele.Id}`}
                            value={this.props.ele.FileUpload?.previewButtonVerticalAlign}
                            checked={this.props.ele.FileUpload?.previewButtonVerticalAlign}
                            onChange={(e)=>{
                                this.props.ele.FileUpload = {...this.props.ele.FileUpload, previewButtonVerticalAlign: e.target.checked}
                                this.props.callback();
                            }}
                        />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>File description</div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Checkbox inputId={`file-upload-description-${this.props.ele.Id}`}
                            name={`fileDescription-${this.props.ele.Id}`}
                            value={this.props.ele.FileUpload?.hasDescription}
                            checked={this.props.ele.FileUpload?.hasDescription}
                            onChange={(e)=>{
                                this.props.ele.FileUpload = {...this.props.ele.FileUpload, hasDescription: e.target.checked}
                                this.props.callback();
                            }}
                        />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Uploaded file display style</div>
                    <div style={{ width: '60%' }}>
                        <Dropdown className="ontario-dropdown-small" showClear options={this.uploadedFileDisplayOptions} optionLabel='label' optionValue='value' value={this.props.ele.FileUpload?.LegacyStyle ? 'legacy' : this.props.ele.FileUpload?.UploadedFileDisplayStyle}
                             onChange={(e) => {
                                this.props.ele.FileUpload = {...this.props.ele.FileUpload, UploadedFileDisplayStyle: e.value};
                                this.props.ele.FileUpload.LegacyStyle = e.value === 'legacy' ? true : null;
                                this.props.callback();
                        }}></Dropdown>

                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Upload Style:</div>
                    <div style={{ width: '30%', display: 'flex'}}>
                        {/* @ts-ignore */}
                        <RadioButton inputId={`upload-style-default-${this.props.ele.Id}`}
                            name={`upload-style-${this.props.ele.Id}`}
                            value='default'
                            checked={!this.props.ele.FileUpload?.UploadStyle || this.props.ele.FileUpload?.UploadStyle==='default'}
                            onChange={(e)=>{
                                if (e.target.checked) {
                                    this.props.ele.FileUpload = {...this.props.ele.FileUpload, UploadStyle: 'default'}
                                    this.props.callback();
                                }
                            }}
                        />
                        <label htmlFor={`upload-style-default-${this.props.ele.Id}`} className="ontario-margin-left-8-!">Default</label>
                    </div>
                    <div style={{ width: '30%', display: 'flex'}}>
                        {/* @ts-ignore */}
                        <RadioButton inputId={`upload-style-inline-error-${this.props.ele.Id}`}
                            name={`upload-style-${this.props.ele.Id}`}
                            value='inline-error'
                            checked={this.props.ele.FileUpload?.UploadStyle==='inline-error'}
                            onChange={(e)=>{
                                if (e.target.checked) {
                                    this.props.ele.FileUpload = {...this.props.ele.FileUpload, UploadStyle: 'inline-error'}
                                    this.props.callback();
                                }
                            }}
                        />
                        <label htmlFor={`upload-style-inline-error-${this.props.ele.Id}`} className="ontario-margin-left-8-!">Inline Error</label>
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Scan File on Upload</div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Checkbox inputId={`file-scan-upload-${this.props.ele.Id}`}
                            name={`upload-scan-${this.props.ele.Id}`}
                            value={this.props.ele.FileUpload?.fileScanOnUpload}
                            checked={this.props.ele.FileUpload?.fileScanOnUpload}
                            onChange={(e)=>{
                                this.props.ele.FileUpload = {...this.props.ele.FileUpload, fileScanOnUpload: e.target.checked}
                                this.props.callback();
                            }}
                        />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Allow Multiple Files</div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Checkbox inputId={`file-upload-multiple-${this.props.ele.Id}`}
                            name={`multiple-files-${this.props.ele.Id}`}
                            value={this.props.ele.FileUpload?.multipleFiles}
                            checked={this.props.ele.FileUpload?.multipleFiles}
                            onChange={(e)=>{
                                this.props.ele.FileUpload = {...this.props.ele.FileUpload, multipleFiles: e.target.checked}
                                this.props.callback();
                            }}
                        />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Multi-part upload</div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Checkbox inputId={`file-upload-batch-${this.props.ele.Id}`}
                            name={`batch-files-${this.props.ele.Id}`}
                            value={this.props.ele.FileUpload?.multiPart}
                            checked={this.props.ele.FileUpload?.multiPart}
                            onChange={(e)=>{
                                this.props.ele.FileUpload = {...this.props.ele.FileUpload, multiPart: e.target.checked}
                                this.props.callback();
                            }}
                        />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Max Number of Files</div>
                    <div style={{ width: '60%' }}>
                        <InputText key={"maxFileCount" + this.props.ele.Sequence}
                            className="ontario-input"
                            value={this.props.ele.FileUpload?.maxFileCount?.toString()}
                            placeholder="e.g., 5"
                            onChange={(e) => {
                                const value = Number(e.target.value);
                                if (!isNaN(value) || e.target.value === '') {
                                    this.props.ele.FileUpload={...this.props.ele.FileUpload ?? {AllowedForUploadFileTypeList: []}, maxFileCount: e.target.value === '' ? undefined : Number(e.target.value)};
                                    this.props.callback();
                                }
                            }}
                        />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Max File Count Error Message</div>
                    <div style={{ width: '60%' }}>
                        <InputText key={"maxFileCountErrorMsg" + this.props.ele.Sequence}
                            className="ontario-input"
                            value={this.props.ele.FileUpload?.maxFileCountErrorMessage}
                            placeholder="You can only upload up to {max} files"
                            onChange={(e) => {
                                this.props.ele.FileUpload={...this.props.ele.FileUpload ?? {AllowedForUploadFileTypeList: []}, maxFileCountErrorMessage: e.target.value};
                                this.props.callback();
                            }}
                        />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>File type prefix</div>
                    <div style={{ width: '60%' }}>
                        <InputText key={"fileTypePrefix" + this.props.ele.Sequence}
                            className="ontario-input"
                            value={this.props.isEng ? (this.props.ele.FileUpload?.fileTypePrefix ?? '') : (this.props.ele.FileUpload?.fileTypePrefixFRA ?? '')}
                            placeholder={this.props.isEng ? "Preferred formats: " : "Formats préférés : "}
                            onChange={(e) => {
                                if (this.props.isEng) {
                                    this.props.ele.FileUpload={...this.props.ele.FileUpload ?? {AllowedForUploadFileTypeList: []}, fileTypePrefix: e.target.value};
                                } else {
                                    this.props.ele.FileUpload={...this.props.ele.FileUpload ?? {AllowedForUploadFileTypeList: []}, fileTypePrefixFRA: e.target.value};
                                }
                                this.props.callback();
                            }}
                        />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>File Size in total</div>
                    <div style={{ width: '60%' }}>
                        <InputText key={"fielSize" + this.props.ele.Sequence}
                            className="ontario-input" 
                            value={this.props.ele.FileUpload?.FileSizeInTotal?.toString()}
                            placeholder="20"
                            onChange={(e) => {
                                const value = Number(e.target.value);
                                if (!isNaN(value)) {
                                    this.props.ele.FileUpload={...this.props.ele.FileUpload ?? {AllowedForUploadFileTypeList: []}, FileSizeInTotal: Number(e.target.value)};
                                    this.props.callback();
                                }
                            }}
                        />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>total Size exceeded error message</div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <InputText key={"size_Error_msg" + this.props.ele.Sequence} className="ontario-input" value={this.props.isEng ? this.props.ele.FileSizeExceedErrorENU : this.props.ele.FileSizeExceedErrorFRA}
                            onChange={(e) => {
                                {/* @ts-ignore */ }
                                if (this.props.isEng) {
                                    {/* @ts-ignore */ }
                                    
                                    this.props.ele.FileUpload.FileSizeExceedErrorENU = e.target.value;
                                } else {
                                    {/* @ts-ignore */ }
                                    this.props.ele.FileUpload.FileSizeExceedErrorFRA = e.target.value;
                                }
                                {/* @ts-ignore */ }
                                this.props.callback();
                            }}
                        />
                    </div>
                    <div style={{ width: '25%' }}>Hide on error</div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Checkbox inputId={`hidePopup-${this.props.ele.Id}`}
                            name={`hidePopup-${this.props.ele.Id}`}
                            value={this.props.ele.FileUpload?.hidePopup}
                            checked={this.props.ele.FileUpload?.hidePopup}
                            onChange={(e)=>{
                                this.props.ele.FileUpload = {...this.props.ele.FileUpload, hidePopup: e.target.checked}
                                this.props.callback();
                            }}
                        />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>File Size</div>
                    <div style={{ width: '60%' }}>
                        <InputText key={"fielSize" + this.props.ele.Sequence}
                            className="ontario-input" 
                            value={this.props.ele.FileUpload?.FileSizeLimit?.toString()}
                            placeholder="20"
                            onChange={(e) => {
                                const value = Number(e.target.value);
                                if (!isNaN(value)) {
                                    this.props.ele.FileUpload={...this.props.ele.FileUpload ?? {AllowedForUploadFileTypeList: []}, FileSizeLimit: Number(e.target.value)};
                                    this.props.callback();
                                }
                            }}
                        />
                    </div>
                </div>
                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Number of max wrong upload attempts</div>
                    <div style={{ width: '60%' }}>
                        <InputText key={"fielSize" + this.props.ele.Sequence}
                            className="ontario-input" 
                            value={this.props.ele.FileUpload?.maxWrongAttemps?.toString()}
                            placeholder="3"
                            onChange={(e) => {
                                const value = Number(e.target.value);
                                if (!isNaN(value)) {
                                    this.props.ele.FileUpload={...this.props.ele.FileUpload ?? {AllowedForUploadFileTypeList: []}, maxWrongAttemps: Number(e.target.value)};
                                    this.props.callback();
                                }
                            }}
                        />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Index after max failed attempt</div>
                    <div style={{ width: '60%' }}>
                        <InputText key={"fielSize" + this.props.ele.Sequence}
                            className="ontario-input" 
                            value={this.props.ele.FileUpload?.indexAfterMaxAttempts?.toString()}
                            placeholder=""
                            onChange={(e) => {
                                const rawValue = e.target.value;
                                const value = Number(rawValue);
                                if (!isNaN(value) || rawValue === '') {
                                    this.props.ele.FileUpload={...(this.props.ele.FileUpload ?? {AllowedForUploadFileTypeList: []}), indexAfterMaxAttempts: rawValue === '' ? undefined : value};
                                    this.props.callback();
                                }
                            }}
                        />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>File size unite:</div>
                    <div style={{ width: '25%', display: 'flex'}}>
                        <RadioButton inputId={`file-size-unit-mb-${this.props.ele.Id}`}
                            name={`file-size-${this.props.ele.Id}`}
                            value='MB'
                            checked={this.props.ele.FileUpload?.SizeUnite === 'KB'}
                            onChange={(e)=>{
                                if (e.target.checked) {
                                    this.props.ele.FileUpload = {...this.props.ele.FileUpload, SizeUnite: 'KB'}
                                    this.props.callback();
                                }
                            }}
                        />
                        <label htmlFor={`file-size-unit-mb-${this.props.ele.Id}`} className="ontario-margin-left-8-!">KB</label>
                    </div>
                    <div style={{ width: '25%', display: 'flex'}}>
                        <RadioButton inputId={`file-size-unit-mb-${this.props.ele.Id}`}
                            name={`file-size-${this.props.ele.Id}`}
                            value='MB'
                            checked={this.props.ele.FileUpload?.SizeUnite === 'MB'}
                            onChange={(e)=>{
                                if (e.target.checked) {
                                    this.props.ele.FileUpload = {...this.props.ele.FileUpload, SizeUnite: 'MB'}
                                    this.props.callback();
                                }
                            }}
                        />
                        <label htmlFor={`file-size-unit-mb-${this.props.ele.Id}`} className="ontario-margin-left-8-!">MB</label>
                    </div>
                    <div style={{ width: '25%', display: 'flex'}}>
                        <RadioButton inputId={`file-size-unit-gb-${this.props.ele.Id}`}
                            name={`file-size-${this.props.ele.Id}`}
                            value='GB'
                            checked={this.props.ele.FileUpload?.SizeUnite === 'GB'}
                            onChange={(e)=>{
                                if (e.target.checked) {
                                    this.props.ele.FileUpload = {...this.props.ele.FileUpload, SizeUnite: 'GB'}
                                    this.props.callback();
                                }
                            }}
                        />
                        <label htmlFor={`file-size-unit-gb-${this.props.ele.Id}`} className="ontario-margin-left-8-!">GB</label>
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>
                        Inline Style:
                    </div>

                    <div style={{ width: '60%' }}>
                        <InputText value={this.props.ele.InlineStyle} className='ontario-input' title="file InlineStyle"
                            onChange={(e) => {
                                this.props.ele.InlineStyle = e.target.value;
                                this.props.callback();
                            }} />
                    </div>
                </div>
                {this.sharableElement()}
            </div>
        )

        return htmlString;
    }

    generateAllowedFileTypeHtml = () => {
        let checkboxHtml=[];
       
        fileTypeList.map((fileType) => {
            checkboxHtml.push( 
                <div key={fileType.label} className="flex align-items-center">
                    {/* @ts-ignore */}
                    <Checkbox inputId={fileType.label} name="fileType" value={fileType.label}
                        onChange={(e)=>{
                            if(e.checked){
                                this.props.ele.FileUpload.AllowedForUploadFileTypeList.push(fileType);
                            } else {
                                this.props.ele.FileUpload.AllowedForUploadFileTypeList = 
                                    this.props.ele.FileUpload.AllowedForUploadFileTypeList.filter(item => fileType.label!==item.label);
                            }
                            this.props.callback();
                        }}
                        checked={this.props.ele.FileUpload.AllowedForUploadFileTypeList.some((item) => fileType.label==item.label)} />
                    <label htmlFor={fileType.label}>{fileType.label}({fileType.val.map(val => (val.ext)).join(', ')})</label>
                </div>
            )
        });

        return checkboxHtml;
    }

    renderFooter = () => {
        return (
            <div>
                {/* @ts-ignore */}
                <Button label="OK" icon="pi pi-check" onClick={() => {
                    this.props.callback(false);
                }} />
                {/* @ts-ignore */}
                <Button label="Cancel" onClick={() => { this.props.callback(false) }} />

            </div>
        );
    }

    render() {
        return (
            this.generateHtmlString()
        )
    }
}
